import type {MessageNamespace} from '@Logger/Constants/MessageNamespace';

import {padWithLeadingZeros} from './padWithLeadingZeros';

const generateMessageCode = (namespace: MessageNamespace, id: number): string =>
    `${padWithLeadingZeros(namespace, 2)}${padWithLeadingZeros(id, 3)}`;

export {generateMessageCode};
